import React, { createContext, useCallback, useContext, useState } from 'react'

// MiniPlayer — global floating video player.
//
// The provider holds at most one active video at a time. Components
// that have a playable video (YouTube card on the YouTube page,
// Reddit v.redd.it video card, etc.) can push themselves into the
// player via openMini(); the MiniPlayer floating component renders
// the iframe at App level so the video survives route navigation.
//
// Shape of `video`:
//   {
//     kind: 'youtube' | 'reddit-mp4',
//     id: string,          // for keying + de-dupe (article id / video id)
//     // YouTube: a video id (extracted from the watch URL)
//     // Reddit: a direct .mp4 url
//     src: string,
//     title?: string,
//     // Reddit videos: paired audio URL (DASH_audio.mp4). Optional.
//     audioSrc?: string,
//   }

const MiniPlayerContext = createContext({
  video: null,
  openMini: () => {},
  closeMini: () => {},
})

export function MiniPlayerProvider({ children }) {
  const [video, setVideo] = useState(null)
  const openMini = useCallback((v) => {
    if (!v || !v.src) return
    setVideo(v)
  }, [])
  const closeMini = useCallback(() => setVideo(null), [])
  return (
    <MiniPlayerContext.Provider value={{ video, openMini, closeMini }}>
      {children}
    </MiniPlayerContext.Provider>
  )
}

export function useMiniPlayer() {
  return useContext(MiniPlayerContext)
}
